<template>
  <div class="property-item is-capitalized">
    <image-card main-class="image" :image="imgCover">
      <div class="tag-container">
        <b-tag
          :type="adTypeClass"
          size="is-small"
          class="has-text-weight-bold is-uppercase"
        >
          {{ adType }}
        </b-tag>
        <b-tag
          v-if="isRentPlus"
          type="is-primary"
          size="is-small"
          class="has-text-weight-bold is-uppercase"
        >
          Plus
        </b-tag>
        <b-tag
          v-if="isAuction"
          type="is-orange"
          size="is-small"
          class="has-text-weight-bold is-uppercase"
        >
          Remate
        </b-tag>
      </div>
      <div class="image-count has-text-white">
        <span class="m-r-sm">{{ totalImages }}</span>
        <vue-fontawesome icon="camera" />
      </div>
    </image-card>
    <div class="property-content p-t-sm p-b-sm">
      <div class="property-content-top">
        <div class="property-type">
          <div class="has-text-weight-bold is-capitalized">
            {{ property.neighborhood }}
          </div>
          <vue-fontawesome icon="share-alt" class="has-text-primary" />
        </div>
        <div>$ {{ formattedPrice }}</div>
        <p class="m-b-none">{{ property.use }}</p>
        <p class="m-b-none">{{ property.address }}</p>
        <p>{{ property.city }}, {{ property.state }}.</p>
      </div>
      <div class="property-content-bottom is-lowercase">
        <div v-if="property.rooms" class="is-inline m-r-md">
          <vue-fontawesome
            :icon="officeType ? 'office' : 'bed-alt'"
            class="has-text-primary"
          />
          <span class="m-l-sm amount">{{ property.rooms }}</span>
        </div>
        <div v-if="property.full_bathrooms" class="is-inline m-r-md">
          <vue-fontawesome icon="shower" class="has-text-primary" />
          <span class="m-l-sm amount">{{ property.full_bathrooms }}</span>
        </div>
        <div v-if="property.parking" class="is-inline m-r-md">
          <vue-fontawesome icon="car" class="has-text-primary" />
          <span class="m-l-sm amount">{{ property.parking }}</span>
        </div>
        <div v-if="property.pets" class="is-inline m-r-md">
          <vue-fontawesome icon="paw" class="has-text-primary" />
        </div>
        <div v-if="property.building_dimensions" class="is-inline m-r-md">
          <vue-fontawesome icon="blue-print" class="has-text-primary" />
          <span class="m-l-sm amount">
            {{ property.building_dimensions }} mts2
          </span>
        </div>
        <div v-if="property.land_dimensions" class="is-inline m-r-md">
          <vue-fontawesome icon="land-dimensions" class="has-text-primary" />
          <span class="m-l-sm amount">{{ property.land_dimensions }} mts2</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PropertyType from "@/constants/properties/ad-type";
import ImageCard from "@/components/ImageCard";

export default {
  name: "PropertyItem",

  components: {
    ImageCard
  },

  props: {
    property: {
      type: Object,
      required: true
    }
  },

  computed: {
    adType() {
      return PropertyType.get[this.property.ad_type];
    },

    imgCover() {
      return this.property.images
        ? this.images[0]
        : "@/assets/images/house_1.jpg";
    },

    adTypeClass() {
      return PropertyType.NUM_SALE != this.property.ad_type
        ? "is-primary-green"
        : "is-primary";
    },

    isRentPlus() {
      return PropertyType.NUM_RENT_PLUS == this.property.ad_type;
    },

    formattedPrice() {
      return new Intl.NumberFormat().format(this.property.price);
    },

    images() {
      return this.property.images.filter(img => {
        let urlSplit = img.split("?");
        urlSplit = urlSplit[0].split(".");
        const lastIndex = urlSplit.length - 1;
        const ext = urlSplit[lastIndex].toLowerCase();

        return ext === "jpg" || ext === "png" || ext === "jpeg";
      });
    },

    totalImages() {
      return this.images.length;
    },

    officeType() {
      const officeProperties = ["Oficina", "Local Comercial", "Bodega"];
      return officeProperties.includes(this.property.use);
    },

    isAuction() {
      return this.property.auction === true;
    }
  },

  methods: {
    removeContextMenu(e) {
      e.preventDefault();
    }
  },

  methods: {
    handleShare(property) {
      console.log("click", property);
    }
  }
};
</script>

<style lang="scss" scoped>
.property-item {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  align-content: stretch;
  flex-wrap: nowrap;
  justify-content: flex-start;
  height: 100%;
  min-height: 360px;

  .image {
    height: 200px;
    border-radius: $radius;
    padding: 0;

    .tag-container {
      width: 100%;
      position: absolute;
      left: 0;
      top: 0;
      display: flex;
      flex-flow: row wrap;
      justify-content: flex-start;
      padding: 1em;
      .tag {
        margin: 0px 4px 4px 0px;
      }
    }

    .image-count {
      position: absolute;
      right: 1em;
      bottom: 1em;
    }
  }

  .property-content {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    justify-content: space-between;

    .property-type {
      display: flex;
      justify-content: space-between;
    }

    p {
      font-size: 0.8em;
    }
  }

  .property-content-bottom {
    display: flex;
    height: 2em;
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch;

    &::-webkit-scrollbar {
      width: 10px;
      height: 10px;
    }

    &::-webkit-scrollbar-thumb {
      background: transparent;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }

    .amount {
      font-size: 0.8em;
    }
  }

  .property-content-bottom > div {
    scroll-snap-align: start;
    flex-shrink: 0;
    width: auto;
    height: 1.5em;
    transform-origin: center center;
    transform: scale(1);
    transition: transform 0.5s;
    position: relative;

    display: flex;
    justify-content: center;
    align-items: center;

    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }
}
</style>
